import { get } from '../utils/httphelper';

export const getPosts = async () => {
    return await get("/posts");
}